import { render } from "./progress_bar.vue?vue&type=template&id=72c4e85f"
import script from "./progress_bar.vue?vue&type=script&lang=js"
export * from "./progress_bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__